import React from "react";
import { FaEdit, FaTrash, FaEye } from "react-icons/fa";

// Ambil akses modul dari localStorage secara aman
const getAccess = (moduleName) => {
  try {
    const auth = JSON.parse(localStorage.getItem("auth"));
    return auth?.access?.[moduleName] || [];
  } catch (err) {
    console.warn("Gagal membaca data auth:", err);
    return [];
  }
};

const DataTable = ({
  data = [],
  onEdit,
  onDelete,
  onView,
  columns = [],
  moduleName = "",
}) => {
  const access = getAccess(moduleName);

  const canView = access.includes("lihat");
  const canEdit = access.includes("edit");
  const canDelete = access.includes("hapus");

  return (
    <div className="overflow-x-auto text-xs rounded-lg shadow-md">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="text-white bg-green-600">
          <tr>
            {columns.map((col) => (
              <th
                key={col.key}
                className="px-3 py-2 font-medium tracking-wide text-left whitespace-nowrap"
              >
                {col.label}
              </th>
            ))}
            {(canView || canEdit || canDelete) && (
              <th className="px-3 py-2 font-medium text-left whitespace-nowrap">
                Aksi
              </th>
            )}
          </tr>
        </thead>

        <tbody className="bg-white divide-y divide-gray-200">
          {data.length > 0 ? (
            data.map((item, index) => (
              <tr
                key={item.id != null ? item.id : index}
                className="transition hover:bg-gray-50"
              >
                {columns.map((col) => (
                  <td
                    key={col.key}
                    className="px-3 py-2 text-gray-700 whitespace-nowrap"
                  >
                    {col.render ? (
                      col.render(item)
                    ) : col.type === "file" && item[col.key] ? (
                      typeof item[col.key] === "object" && item[col.key].url ? (
                        <a
                          href={item[col.key].url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-600 underline"
                        >
                          {item[col.key].name || "Lihat File"}
                        </a>
                      ) : (
                        <a
                          href={item[col.key]}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-600 underline"
                        >
                          Lihat File
                        </a>
                      )
                    ) : (
                      item[col.key] ?? "-"
                    )}
                  </td>
                ))}

                {(canView || canEdit || canDelete) && (
                  <td className="flex items-center gap-2 px-2 py-2">
                    {canView && onView && (
                      <button
                        onClick={() => onView(index)}
                        className="text-sm text-emerald-500 hover:text-emerald-600"
                        title="Lihat Detail"
                      >
                        <FaEye size={14} />
                      </button>
                    )}
                    {canEdit && onEdit && (
                      <button
                        onClick={() => onEdit(index)}
                        className="text-sm text-yellow-500 hover:text-yellow-600"
                        title="Edit"
                      >
                        <FaEdit size={14} />
                      </button>
                    )}
                    {canDelete && onDelete && (
                      <button
                        onClick={() => onDelete(index)}
                        className="text-sm text-red-500 hover:text-red-600"
                        title="Hapus"
                      >
                        <FaTrash size={14} />
                      </button>
                    )}
                  </td>
                )}
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan={columns.length + 1}
                className="py-6 text-center text-gray-500"
              >
                Tidak ada data yang tersedia.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default DataTable;
